import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=6ded7fea&scoped=true"
import script from "./Outbound.vue?vue&type=script&lang=js"
export * from "./Outbound.vue?vue&type=script&lang=js"
import style0 from "./Outbound.vue?vue&type=style&index=0&id=6ded7fea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded7fea",
  null
  
)

export default component.exports